import { default as _indexByXTAZiS4jMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250722074447/pages/_index.vue?macro=true";
import { default as _91_46_46_46cms_93RWGB9EXgKNMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250722074447/pages/[...cms].vue?macro=true";
import { default as indexoXhl202C0jMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250722074447/pages/cart/index.vue?macro=true";
import { default as indexmcz3A8HVNLMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250722074447/pages/cart/success/index.vue?macro=true";
import { default as _91_46_46_46slug_93KYGfMoecZ4Meta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250722074447/pages/catalog/[...slug].vue?macro=true";
import { default as indexLgHgmS9XV2Meta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250722074447/pages/catalog/index.vue?macro=true";
import { default as _91_46_46_46slug_933f8uqHEuBGMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250722074447/pages/collection/[...slug].vue?macro=true";
import { default as indexJLFqzqLAogMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250722074447/pages/email/index.vue?macro=true";
import { default as indexqiIYE7ErkAMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250722074447/pages/kontakty/index.vue?macro=true";
import { default as _91_46_46_46slug_93WC8HQQeKGSMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250722074447/pages/product/[...slug].vue?macro=true";
import { default as indextmvUJvZNwxMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250722074447/pages/search/index.vue?macro=true";
import { default as index6GtY0h5bgkMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250722074447/pages/wishlist/index.vue?macro=true";
export default [
  {
    name: _indexByXTAZiS4jMeta?.name ?? "_index",
    path: _indexByXTAZiS4jMeta?.path ?? "/_index",
    meta: _indexByXTAZiS4jMeta || {},
    alias: _indexByXTAZiS4jMeta?.alias || [],
    redirect: _indexByXTAZiS4jMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250722074447/pages/_index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46cms_93RWGB9EXgKNMeta?.name ?? "cms",
    path: _91_46_46_46cms_93RWGB9EXgKNMeta?.path ?? "/:cms(.*)*",
    meta: _91_46_46_46cms_93RWGB9EXgKNMeta || {},
    alias: _91_46_46_46cms_93RWGB9EXgKNMeta?.alias || [],
    redirect: _91_46_46_46cms_93RWGB9EXgKNMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250722074447/pages/[...cms].vue").then(m => m.default || m)
  },
  {
    name: indexoXhl202C0jMeta?.name ?? "cart",
    path: indexoXhl202C0jMeta?.path ?? "/cart",
    meta: indexoXhl202C0jMeta || {},
    alias: indexoXhl202C0jMeta?.alias || [],
    redirect: indexoXhl202C0jMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250722074447/pages/cart/index.vue").then(m => m.default || m)
  },
  {
    name: indexmcz3A8HVNLMeta?.name ?? "cart-success",
    path: indexmcz3A8HVNLMeta?.path ?? "/cart/success",
    meta: indexmcz3A8HVNLMeta || {},
    alias: indexmcz3A8HVNLMeta?.alias || [],
    redirect: indexmcz3A8HVNLMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250722074447/pages/cart/success/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93KYGfMoecZ4Meta?.name ?? "catalog-slug",
    path: _91_46_46_46slug_93KYGfMoecZ4Meta?.path ?? "/catalog/:slug(.*)*",
    meta: _91_46_46_46slug_93KYGfMoecZ4Meta || {},
    alias: _91_46_46_46slug_93KYGfMoecZ4Meta?.alias || [],
    redirect: _91_46_46_46slug_93KYGfMoecZ4Meta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250722074447/pages/catalog/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexLgHgmS9XV2Meta?.name ?? "catalog",
    path: indexLgHgmS9XV2Meta?.path ?? "/catalog",
    meta: indexLgHgmS9XV2Meta || {},
    alias: indexLgHgmS9XV2Meta?.alias || [],
    redirect: indexLgHgmS9XV2Meta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250722074447/pages/catalog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_933f8uqHEuBGMeta?.name ?? "collection-slug",
    path: _91_46_46_46slug_933f8uqHEuBGMeta?.path ?? "/collection/:slug(.*)*",
    meta: _91_46_46_46slug_933f8uqHEuBGMeta || {},
    alias: _91_46_46_46slug_933f8uqHEuBGMeta?.alias || [],
    redirect: _91_46_46_46slug_933f8uqHEuBGMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250722074447/pages/collection/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexJLFqzqLAogMeta?.name ?? "email",
    path: indexJLFqzqLAogMeta?.path ?? "/email",
    meta: indexJLFqzqLAogMeta || {},
    alias: indexJLFqzqLAogMeta?.alias || [],
    redirect: indexJLFqzqLAogMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250722074447/pages/email/index.vue").then(m => m.default || m)
  },
  {
    name: indexqiIYE7ErkAMeta?.name ?? "kontakty",
    path: indexqiIYE7ErkAMeta?.path ?? "/kontakty",
    meta: indexqiIYE7ErkAMeta || {},
    alias: indexqiIYE7ErkAMeta?.alias || [],
    redirect: indexqiIYE7ErkAMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250722074447/pages/kontakty/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93WC8HQQeKGSMeta?.name ?? "product-slug",
    path: _91_46_46_46slug_93WC8HQQeKGSMeta?.path ?? "/product/:slug(.*)*",
    meta: _91_46_46_46slug_93WC8HQQeKGSMeta || {},
    alias: _91_46_46_46slug_93WC8HQQeKGSMeta?.alias || [],
    redirect: _91_46_46_46slug_93WC8HQQeKGSMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250722074447/pages/product/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indextmvUJvZNwxMeta?.name ?? "search",
    path: indextmvUJvZNwxMeta?.path ?? "/search",
    meta: indextmvUJvZNwxMeta || {},
    alias: indextmvUJvZNwxMeta?.alias || [],
    redirect: indextmvUJvZNwxMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250722074447/pages/search/index.vue").then(m => m.default || m)
  },
  {
    name: index6GtY0h5bgkMeta?.name ?? "wishlist",
    path: index6GtY0h5bgkMeta?.path ?? "/wishlist",
    meta: index6GtY0h5bgkMeta || {},
    alias: index6GtY0h5bgkMeta?.alias || [],
    redirect: index6GtY0h5bgkMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250722074447/pages/wishlist/index.vue").then(m => m.default || m)
  }
]